import { AnimatePresence, motion } from 'framer-motion'
import React, { Fragment, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

import { checkIsLoadScript } from '@/utils/tool'

export default function Index() {
  useEffect(() => {
    if (!checkIsLoadScript('zhichi_4_5')) {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://imgvip.meishubao.com/vip/mpc/js/zhichi_4_5.js?version=20220314'
      document.body.appendChild(script)
    }
  }, [])
  return (
    <Container>
      <div className="online_service">
        <div className="service_cont webchat">
          <i className="icon icon-chat" />
          <span>在线咨询</span>
          <div className="pop">点击开始 在线咨询</div>
        </div>
        <div className="service_cont phone">
          <i className="icon icon-phone" />
          <span>电话咨询</span>
          <div className="pop">请拨打咨询电话 400-622-6190</div>
        </div>
        <div className="service_cont code last-child">
          <i className="icon icon-code" />
          <span>公众号</span>
          <div className="pop">
            <img src="https://imgvip.meishubao.com/vip/mpc/images/icon_code_new.png" alt="" />
            <p>关注美术宝1对1公众号，随时接收上课通知，查看课时记录。</p>
          </div>
        </div>
        <div className="service_cont back_top">
          <a href="#">
            <div className="back_wrap">
              <img src="https://imgvip.meishubao.com/vip/mpc/images/back_top.png" alt="" />
            </div>
          </a>
        </div>
      </div>
    </Container>
  )
}

const Container = styled(motion.div)`
  .online_service {
    position: fixed;
    top: 160px;
    right: 0;
    z-index: 101;
  }
  .online_service .service_cont {
    position: relative;
    box-sizing: border-box;
    font-size: 14px;
    width: 70px;
    height: 73px;
    color: #313131;
    padding-top: 10px;
    text-align: center;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
  .online_service .service_cont:first-child {
    border-radius: 8px 0 0 0;
  }
  .online_service .service_cont.last-child {
    border-radius: 0 0 0 8px;
  }
  .online_service .service_cont .icon {
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 100%;
    background: no-repeat center;
  }
  .online_service .service_cont .icon-chat {
    background-image: url('https://imgvip.meishubao.com/vip/mpc/images/icon-chat.png');
  }
  .online_service .service_cont .icon-phone {
    background-image: url('https://imgvip.meishubao.com/vip/mpc/images/phone_chat.png');
  }
  .online_service .service_cont .icon-code {
    background-image: url('https://imgvip.meishubao.com/vip/mpc/images/code_chat.png');
  }
  .online_service .webchat .pop {
    background: #f24141;
  }
  .online_service .phone .pop {
    background: #ffa32c;
  }
  .online_service .service_cont.webchat .pop:after {
    border-left-color: #f24141;
  }
  .online_service .service_cont.phone .pop:after {
    border-left-color: #ffa32c;
  }
  .online_service .service_cont.code .pop:after {
    border-left-color: #8ddc47;
  }
  .online_service .service_cont span {
    display: inline-block;
  }
  .online_service .service_cont .pop {
    display: none;
    font-size: 16px;
    position: absolute;
    top: 25%;
    right: 80px;
    white-space: nowrap;
    height: 45px;
    line-height: 23px;
    padding: 10px 20px;
    color: #fff;
    box-shadow: 2px 2px 5px rgba(50, 50, 50, 0.1);
    border-radius: 5px;
    box-sizing: border-box;
  }
  .online_service .service_cont.code .pop {
    max-width: 200px;
    width: 150px;
    padding: 10px;
    text-align: left;
    background: #8ddc47;
    margin-top: -120px;
    height: auto;
    white-space: normal;
  }
  .online_service .service_cont.code .pop img {
    width: 130px;
    margin-bottom: 10px;
    border: 4px solid #fff;
    border-radius: 4px;
  }
  .online_service .service_cont.code .pop:after {
    top: 140px;
  }
  .online_service .service_cont .pop:after {
    content: '';
    position: absolute;
    right: -18px;
    top: 22px;
    margin-top: -8px;
    border: 9px solid transparent;
  }
  .back_top {
    display: none;
  }
  .online_service .service_cont a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
  .online_service .service_cont a .back_wrap {
    width: 32px;
    display: inline-block;
    line-height: 63px;
  }
  .online_service .service_cont a img {
    width: 100%;
  }
  .online_service .service_cont:hover .pop {
    display: block;
  }
`
